import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient } from '@tanstack/react-query';

import { GlobalLoadingContextProvider } from 'contexts/GlobalLoadingContext';
import App from './App.tsx';
import { GlobalLoader } from 'components/GlobalLoader';
import './Main.scss';

// ignore network state in query/mutation layer, as this layer only talks directly to RxDB storage 
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always'
    },
    mutations: {
      networkMode: 'always'
    }
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalLoadingContextProvider>
      <>
        <GlobalLoader />
        <App queryClient={queryClient} />
      </>
    </GlobalLoadingContextProvider>
  </StrictMode>
);
